export enum EmployeeRole {
  ADMIN = "admin",
  TEAM = "team",
  ANX_READ = "anx_read",
  ANX_WRITE = "anx_write",
}

export default interface Employee {
  id: string;
  name: string;
  email: string;
  role: EmployeeRole;
  rows_limit: number;
  status: string;
  created_at: string;
}
